import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';

import api from '../../services/api';
import { ContainerProduct } from './style.js';

import Menu from '../../components/Menu';
import Footer from '../../components/Footer';
import AuthGuard from '../../components/AuthGuard';
import ButtonDefault from '../../components/ButtonDefault';
import SelectDefault from '../../components/SelectDefault';
import ButtonAction from '../../components/ButtonAction';
import InputDefault from '../../components/InputDefault';

const ParametersList = () => {
  document.title = 'Datamais - Listagem de Parâmetros';

  const [closeModelDeleteParameters, setDeleteParameters] = useState(false);
  const DeleteParametersModelControll = () => setDeleteParameters(false);
  const [detailsParameters, setDetailsParameters] = useState({});
  const [iD_DM990, setID_DM990] = useState({});

  const [parametersList, setParametersList] = useState([]);

  const [parametersValue, setParametersValue] = useState('');
  const [parametersKey, setParametersKey] = useState('');
  const [situation, setSituation] = useState('');

  useEffect(() => {
    api
      .get('get_all_parms')
      .then((response) => {
        setParametersList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const filterParameters = () => {
    const dataFilter = {
      DS_KEY_PARAMETRO: parametersKey,
      DS_VALOR_PARAMETRO: parametersValue,
      TP_PARAMETRO: situation
    };

    api
      .post('filter_parms', dataFilter)
      .then((response) => {
        setParametersList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const DeleteParametersAccount = (ID_DM990) => {
    const dataDelete = {
      ID_DM990: ID_DM990
    };
    api
      .delete('delete_parm', { data: dataDelete })
      .then((response) => {
        if (response.data.success) {
          toast.success(response.data.message);
          filterParameters();
        } else {
          toast.warning(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <AuthGuard />
      <Container>
        <ContainerProduct>
          <Menu />
          <h2>Lista de Parâmetros</h2>
          <Row>
            <Col xs={6}>
              <InputDefault
                placeholder="Chave do Parâmetro"
                Width={'100%'}
                Margin={'10px 0px 15px 0px'}
                Text={'Chave do Parâmetro'}
                onChange={(e) => setParametersKey(e.target.value)}
              />
            </Col>
            <Col xs={6}>
              <InputDefault
                placeholder="Valor do Parâmetro"
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                Width={'100%'}
                Margin={'10px 0px 15px 0px'}
                Text={'Valor do Parâmetro'}
                onChange={(e) => setParametersValue(e.target.value)}
              />
            </Col>
            <Col xs={6}>
              <SelectDefault
                Width={'100%'}
                Margin={'10px 0px 15px 0px'}
                Text={'Situação'}
                onChange={(e) => setSituation(e.target.value)}>
                <option value="">Selecionar</option>
                <option value="STRING">Letra</option>
                <option value="INT">Número</option>
              </SelectDefault>
            </Col>
          </Row>
          <ButtonDefault
            Width={'150px'}
            Margin={'20px 30px 30px 0px'}
            Text="Buscar"
            onClick={filterParameters}
          />
          <Table striped bordered hover variant="light">
            <thead>
              <tr>
                <th>Chave do Parâmetro</th>
                <th>Valor do Parâmetro</th>
                <th>Informações do Parâmetro</th>
                <th>Situação</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              {parametersList.map((parameters) => (
                // eslint-disable-next-line react/jsx-key
                <tr>
                  <td>{parameters.DS_KEY_PARAMETRO}</td>
                  <td>{parameters.DS_VALOR_PARAMETRO}</td>
                  <td>{parameters.DS_INF_PARAMETRO}</td>
                  <td>{parameters.TP_PARAMETRO == 'STRING' ? 'Letra' : 'Número'}</td>
                  <td style={{ textAlign: 'center' }}>
                    <ButtonAction
                      Action="Remove"
                      onClick={() => {
                        setDetailsParameters(parameters.DS_KEY_PARAMETRO);
                        setDeleteParameters(true);
                        setID_DM990(parameters.ID_DM990);
                      }}
                    />
                    &nbsp;&nbsp;
                    <Link to={`./edit/${parameters.ID_DM990}`}>
                      <ButtonAction Action="Edit" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ContainerProduct>
        <ToastContainer />
      </Container>
      <Footer />
    </>
  );
};

export default ParametersList;
